// ─── SERVICES DATA ───────────────────────────────────────────────────────────

export const CATEGORIES = [
  { id: 'all',           label: 'All Services',   color: 'navy'    },
  { id: 'travel',        label: 'Travel & Jets',  color: 'saffron' },
  { id: 'accommodation', label: 'Accommodation',  color: 'teal'    },
  { id: 'education',     label: 'Education',      color: 'gold'    },
  { id: 'jobs',          label: 'Jobs & Visa',    color: 'navy'    },
  { id: 'tourism',       label: 'Tourism',        color: 'saffron' },
  { id: 'business',      label: 'Business',       color: 'teal'    },
  { id: 'lifestyle',     label: 'Lifestyle',      color: 'gold'    },
];

export const SERVICES = [
  // ── TRAVEL & JETS
  {
    id: 1, cat: 'travel', icon: '✈️', color: 'saffron',
    title: 'Private Jet Charter – Ride Booking',
    short: 'Book a private jet ride from Mumbai bombay international worldwide to anywhere in the world.',
    description: 'Experience seamless private jet charter ride booking from Mumbai bombay international worldwide to all countries worldwide. We handle every detail — from airport transfers to onboard catering — for an unmatched travel experience.',
    features: ['Worldwide destinations', 'Luxury onboard service', 'Instant booking', 'Corporate & leisure'],
  },
  {
    id: 2, cat: 'travel', icon: '🛩️', color: 'saffron',
    title: 'Private Jet – Rent, Purchase & Selling',
    short: 'Rent or own your private jet in Mumbai bombay international worldwide. Full purchase and selling services.',
    description: 'Whether you want to rent a private jet for a trip, purchase your own aircraft, or sell an existing one, our expert team manages every step of the process in Mumbai bombay international worldwide and internationally.',
    features: ['Short & long-term rental', 'Aircraft purchase advisory', 'Selling & valuation', 'International deals'],
  },
  {
    id: 3, cat: 'travel', icon: '🛫', color: 'saffron',
    title: 'Flight Ticket Booking',
    short: 'Domestic and international flight tickets from Mumbai bombay international worldwide.',
    description: 'Book domestic and international flight tickets at competitive prices. Available for all airlines from Mumbai bombay international worldwide and Bombay airports. Get assistance with seat selection, baggage, and travel insurance.',
    features: ['All airlines', 'Best price guarantee', 'Group bookings', 'Visa support'],
  },
  {
    id: 4, cat: 'travel', icon: '🎖️', color: 'saffron',
    title: 'Private Jet Air Hostess Course',
    short: 'Professional training for private jet cabin crew roles in Mumbai bombay international worldwide.',
    description: 'Specialized air hostess course designed for private jet and charter flight environments. Includes grooming, safety protocols, international etiquette, and luxury service training, available right here in Mumbai bombay international worldwide.',
    features: ['Certified program', 'Grooming & etiquette', 'Safety training', 'Job placement'],
  },

  // ── ACCOMMODATION
  {
    id: 5, cat: 'accommodation', icon: '🏨', color: 'teal',
    title: '5-Star Hotel Membership & Booking',
    short: 'Exclusive 5-star hotel memberships and reservations in Mumbai bombay international worldwide.',
    description: 'Access premium 5-star hotels across Mumbai bombay international worldwide and internationally through our exclusive membership programs. Enjoy priority booking, special rates, and luxury amenities.',
    features: ['Membership cards', 'Priority reservations', 'International hotels', 'Corporate packages'],
  },
  {
    id: 6, cat: 'accommodation', icon: '🛏️', color: 'teal',
    title: 'Paying Guest (PG) Accommodation',
    short: 'Safe, comfortable PG rooms for girls and boys all over Mumbai bombay international worldwide.',
    description: 'Find the perfect paying guest accommodation across all areas of Mumbai bombay international worldwide. We offer verified, safe, and affordable PG rooms for students, working professionals, and newcomers to the city.',
    features: ['Girls & boys options', 'All Mumbai bombay international worldwide areas', 'Verified properties', 'Meals included option'],
  },
  {
    id: 7, cat: 'accommodation', icon: '🏢', color: 'teal',
    title: 'Rooms, Offices, Shops & Warehouses',
    short: 'Rental spaces for every need across Mumbai bombay international worldwide.',
    description: 'Find rooms, offices, shops, mini stores, and warehouses to rent or purchase anywhere in Mumbai bombay international worldwide and Bombay. Suitable for individuals, startups, and established businesses.',
    features: ['Short & long-term lease', 'Commercial & residential', 'All Mumbai bombay international worldwide zones', 'Legal documentation help'],
  },
  {
    id: 8, cat: 'accommodation', icon: '🏩', color: 'teal',
    title: 'Dormitory Stays – Daily & Per Day Basis',
    short: 'Affordable dorms for short-term stays across Mumbai bombay international worldwide.',
    description: 'Budget-friendly dormitory accommodations available on a daily or per-day basis for students, backpackers, and short-term visitors to Mumbai bombay international worldwide. Safe, clean, and centrally located options.',
    features: ['Daily basis available', 'Budget friendly', 'Safe & clean', 'Girls & boys dorms'],
  },
  {
    id: 9, cat: 'accommodation', icon: '🎊', color: 'teal',
    title: 'Party Halls on Rent',
    short: 'Fully equipped party and event halls across Mumbai bombay international worldwide.',
    description: 'Book beautiful, fully-equipped party halls and event spaces for birthdays, weddings, corporate events, and more across all areas of Mumbai bombay international worldwide. Catering and decoration services available.',
    features: ['All event types', 'Catering available', 'Decoration options', 'Affordable rates'],
  },

  // ── EDUCATION
  {
    id: 10, cat: 'education', icon: '✈️', color: 'gold',
    title: 'Air Hostess & Ground Staff Course',
    short: 'Professional cabin crew and airport staff training in Mumbai bombay international worldwide.',
    description: 'Become a certified air hostess or airport ground staff with our comprehensive training programs in Mumbai bombay international worldwide. Courses cover grooming, communication, passenger handling, safety, and emergency procedures.',
    features: ['DGCA aligned curriculum', 'Interview preparation', 'Uniform & grooming', 'Job placement support'],
  },
  {
    id: 11, cat: 'education', icon: '🛩️', color: 'gold',
    title: 'Pilot Training Academy',
    short: 'Commercial and private pilot training from Mumbai bombay international worldwide.',
    description: 'Pursue your dream of flying with our accredited pilot training programs. Offering CPL, PPL, and online pilot courses with connections to flight schools in Mumbai bombay international worldwide and internationally.',
    features: ['CPL & PPL programs', 'Online training available', 'International schools', 'ATPL pathways'],
  },
  {
    id: 12, cat: 'education', icon: '🍽️', color: 'gold',
    title: 'Hotel Management Course',
    short: 'Full hotel management training in Mumbai bombay international worldwide with international job placement.',
    description: 'Comprehensive hotel and hospitality management courses in Mumbai bombay international worldwide covering food & beverage, housekeeping, front office, and event management. Includes cruise ship job training and international placements.',
    features: ['1–3 year programs', 'Cruise ship job training', 'International placement', 'Industry internships'],
  },
  {
    id: 13, cat: 'education', icon: '🏥', color: 'gold',
    title: 'MBBS / BAMS / BDS Programs',
    short: 'Medical degree admissions in Mumbai bombay international worldwide and abroad.',
    description: 'Get guidance and admission assistance for MBBS, BAMS (Ayurveda), and BDS (Dental) programs in Mumbai bombay international worldwide and recognized universities worldwide including Russia, Kazakhstan, and Philippines.',
    features: ['Global options', 'NEET counselling help', 'Visa & documentation', 'Hostel arrangements'],
  },
  {
    id: 14, cat: 'education', icon: '🎓', color: 'gold',
    title: 'MBA / BBA / Engineering Admissions',
    short: 'College admissions for top programs through our Mumbai bombay international worldwide hub.',
    description: 'End-to-end assistance for college admissions in MBA, BBA, B.Tech, M.Tech, and post-graduation courses. We connect students to top colleges in Mumbai bombay international worldwide and internationally.',
    features: ['Top college network', 'Scholarship guidance', 'Entrance exam prep', 'International universities'],
  },
  {
    id: 15, cat: 'education', icon: '💻', color: 'gold',
    title: 'Computer & IT Courses',
    short: 'Graphics design, web dev, Tally, MS Office in Mumbai bombay international worldwide.',
    description: 'Master in-demand digital skills with our wide range of computer and IT courses in Mumbai bombay international worldwide. From basic MS Office to advanced web development, data science, ethical hacking, and hardware training.',
    features: ['Beginner to advanced', 'Certified courses', 'Job-ready curriculum', 'Flexible timing'],
  },
  {
    id: 16, cat: 'education', icon: '💄', color: 'gold',
    title: 'Beauty, Mehndi & Fashion Courses',
    short: 'Professional beauty, fashion designing & embroidery classes in Mumbai bombay international worldwide.',
    description: 'Build a career in the beauty and fashion industry with our professional courses in Mumbai bombay international worldwide. We offer mehndi (henna), beauty therapy, fashion designing, embroidery, and related creative arts.',
    features: ['Practical training', 'Certificate awarded', 'Own business guidance', 'Flexible batches'],
  },
  {
    id: 17, cat: 'education', icon: '📐', color: 'gold',
    title: 'Interior Design Course',
    short: 'Professional interior design courses and institute admissions in Mumbai bombay international worldwide.',
    description: 'Enroll in reputed interior design institutes in Mumbai bombay international worldwide. Courses cover space planning, 3D visualization, AutoCAD, materials, and project management for residential and commercial design.',
    features: ['AutoCAD & 3D tools', 'Live projects', 'Portfolio development', 'Industry mentors'],
  },
  {
    id: 18, cat: 'education', icon: '🎭', color: 'gold',
    title: 'Modelling, Acting & Dance Academy',
    short: 'Bollywood, TV, web series, Hollywood & dance admissions in Mumbai bombay international worldwide.',
    description: 'Launch your entertainment career with admissions to top modelling, acting, and dance academies in Mumbai bombay international worldwide. Courses for TV serials, Bollywood, Hollywood, web series, and music videos.',
    features: ['Bollywood & OTT', 'Portfolio shoots', 'Audition preparation', 'Open to all ages'],
  },
  {
    id: 19, cat: 'education', icon: '🌍', color: 'gold',
    title: 'Study Abroad Programs',
    short: 'Study in Singapore, Germany, UK, USA, Japan, Dubai from Mumbai bombay international worldwide.',
    description: 'Complete assistance for studying abroad from Mumbai bombay international worldwide — from choosing the right university to visa processing, accommodation, and pre-departure orientation. Available for 50+ countries worldwide.',
    features: ['50+ countries', 'Visa processing', 'Scholarship search', 'Pre-departure support'],
  },
  {
    id: 20, cat: 'education', icon: '🏊', color: 'gold',
    title: 'Swimming Course',
    short: 'Swimming lessons and pool access across Mumbai bombay international worldwide.',
    description: 'Learn swimming with certified coaches at top pools across Mumbai bombay international worldwide. Available for beginners, intermediates, and competitive swimmers. Kids and adult batches available.',
    features: ['All skill levels', 'Certified coaches', 'Kids & adults', 'Multiple locations'],
  },
  {
    id: 21, cat: 'education', icon: '🎯', color: 'gold',
    title: 'Air Rifle Shooting Training',
    short: 'Certified air rifle shooting training institute in Mumbai bombay international worldwide.',
    description: 'Train with professional coaches at certified air rifle shooting institutes in Mumbai bombay international worldwide. Suitable for beginners and competitive shooters aiming for state and national level competitions.',
    features: ['ISSF certified', 'Competition preparation', 'Equipment provided', 'Safety training'],
  },

  // ── JOBS & VISA
  {
    id: 22, cat: 'jobs', icon: '🛂', color: 'navy',
    title: 'Work Permit & Job Visa Abroad',
    short: 'Job placement with work visa in 20+ countries from Mumbai bombay international worldwide.',
    description: 'Get placed in verified jobs abroad with full work permit and visa assistance from Mumbai bombay international worldwide. We serve 20+ countries including UAE, UK, Germany, Japan, Singapore, Canada, and Australia.',
    features: ['20+ countries', 'Verified employers', 'Visa processing', 'Pre-departure training'],
  },
  {
    id: 23, cat: 'jobs', icon: '🛫', color: 'navy',
    title: 'Airport Jobs – Mumbai bombay international worldwide & International',
    short: 'Air hostess and ground staff jobs at Mumbai bombay international worldwide and world airports.',
    description: 'Get placed as an air hostess or airport ground staff at Mumbai bombay international worldwide airport and international airports worldwide. Full training, grooming, and interview preparation included.',
    features: ['Mumbai bombay international worldwide airport', 'International airports', 'Grooming training', 'Interview prep'],
  },
  {
    id: 24, cat: 'jobs', icon: '⏰', color: 'navy',
    title: 'Part Time & Full Time Jobs – Mumbai bombay international worldwide',
    short: 'Verified part-time and full-time job opportunities across Mumbai bombay international worldwide.',
    description: 'Find verified part-time and full-time job opportunities across all industries in Mumbai bombay international worldwide. We connect job seekers with reputed employers in hospitality, retail, IT, and more.',
    features: ['All industries', 'Immediate openings', 'Salary negotiation', 'Career guidance'],
  },
  {
    id: 25, cat: 'jobs', icon: '🚢', color: 'navy',
    title: 'Cruise Ship Jobs',
    short: 'Cruise ship job training and international placements from Mumbai bombay international worldwide.',
    description: 'Join leading international cruise lines with our placement and training services in Mumbai bombay international worldwide. Roles available in hospitality, entertainment, housekeeping, and deck operations on global cruise ships.',
    features: ['International cruise lines', 'Free accommodation', 'Salary in USD/EUR', 'Full training included'],
  },
  {
    id: 26, cat: 'jobs', icon: '📄', color: 'navy',
    title: 'Passport Services',
    short: 'Passport application, renewal, and documentation in Mumbai bombay international worldwide.',
    description: 'Complete assistance with passport applications, renewals, and documentation in Mumbai bombay international worldwide. We guide you through the entire process — from form filling to appointment scheduling and collection.',
    features: ['New applications', 'Renewal assistance', 'Tatkaal service', 'Document checklist'],
  },

  // ── TOURISM
  {
    id: 27, cat: 'tourism', icon: '🗺️', color: 'saffron',
    title: 'Online Tourist Guide – Mumbai bombay international worldwide',
    short: 'Expert guides for Mumbai bombay international worldwide city tours for foreign visitors.',
    description: 'Explore Mumbai bombay international worldwide with our knowledgeable tourist guides who specialize in showing international visitors the best of the city. Available in multiple languages for a personalized experience.',
    features: ['Multilingual guides', 'Custom itineraries', 'Historical & modern', 'Online & in-person'],
  },
  {
    id: 28, cat: 'tourism', icon: '🏍️', color: 'saffron',
    title: 'Bike, Car & Bus City Tours',
    short: 'Day and night Mumbai bombay international worldwide tours by bike, car, and bus.',
    description: 'Experience Mumbai bombay international worldwide like never before on our guided bike, car, and bus tours. Available for day and night tours covering Marine Drive, gateway , Dharavi, and more iconic spots.',
    features: ['Day & night tours', 'Multiple vehicles', 'Custom routes', 'Photography stops'],
  },
  {
    id: 29, cat: 'tourism', icon: '🚲', color: 'saffron',
    title: 'Bike on Rent – Mumbai bombay international worldwide',
    short: 'New bikes available for self-ride rentals across Mumbai bombay international worldwide.',
    description: 'Rent brand new bikes for self-guided exploration of Mumbai bombay international worldwide. Hourly, daily, and weekly rental options available. Helmets and safety gear included. Delivery to your location possible.',
    features: ['New bikes', 'Hourly & daily rental', 'Safety gear included', 'Home delivery'],
  },
  {
    id: 30, cat: 'tourism', icon: '🚌', color: 'saffron',
    title: 'Mumbai bombay international worldwide Metro Pass',
    short: 'Metro pass assistance and smart card services in Mumbai bombay international worldwide.',
    description: 'Get help with Mumbai bombay international worldwide Metro smart card issuance, top-up, and monthly passes. We assist foreign visitors and newcomers with navigating the Mumbai bombay international worldwide Metro network efficiently.',
    features: ['Smart card issuance', 'Monthly passes', 'Top-up assistance', 'Route guidance'],
  },
  {
    id: 31, cat: 'tourism', icon: '🍛', color: 'saffron',
    title: 'Hotel Food & Catering Services',
    short: 'Hotel-quality food and catering in Mumbai bombay international worldwide for events and daily meals.',
    description: 'Order hotel-quality food and professional catering services across Mumbai bombay international worldwide. Perfect for events, corporate lunches, tourist groups, or daily meal subscriptions. All cuisines available.',
    features: ['All cuisines', 'Event catering', 'Daily subscriptions', 'Hygiene certified'],
  },

  // ── BUSINESS
  {
    id: 32, cat: 'business', icon: '🏭', color: 'teal',
    title: 'Manufacturer & Factory Products',
    short: 'Manufacturer and factory goods through our Mumbai bombay international worldwide network.',
    description: 'Source all types of manufactured and factory products directly from Mumbai bombay international worldwide-based manufacturers for your business needs. Available for purchase and bulk selling internationally.',
    features: ['Direct from factory', 'Bulk orders', 'International export', 'Quality certified'],
  },
  {
    id: 33, cat: 'business', icon: '🌐', color: 'teal',
    title: 'Website Development & Google Promotion',
    short: 'Professional websites and digital marketing in Mumbai bombay international worldwide.',
    description: 'Build a powerful online presence with our website development and Google promotion services. We design, develop, and market websites for businesses of all sizes in Mumbai bombay international worldwide and internationally.',
    features: ['Custom web design', 'SEO optimized', 'Google Ads management', 'Social media marketing'],
  },
  {
    id: 34, cat: 'business', icon: '💻', color: 'teal',
    title: 'Laptop, Computer & Mobile – Buy & Sell',
    short: 'Purchase and sell electronics at best prices in Mumbai bombay international worldwide.',
    description: 'Buy or sell laptops, desktop computers, and mobile phones at the best prices in Mumbai bombay international worldwide. New and refurbished options available with warranty. Corporate bulk purchases welcome.',
    features: ['New & refurbished', 'Warranty included', 'Corporate bulk deals', 'Buyback service'],
  },
  {
    id: 35, cat: 'business', icon: '⚙️', color: 'teal',
    title: 'Factory & Industrial Machines',
    short: 'Industrial machines available for purchase and sale in Mumbai bombay international worldwide.',
    description: 'Source industrial and factory machines for your manufacturing business. Wide range available — from CNC machines to packaging equipment — available for purchase and international export in Mumbai bombay international worldwide.',
    features: ['Wide machine range', 'New & used options', 'Installation support', 'Export available'],
  },

  // ── LIFESTYLE
  {
    id: 36, cat: 'lifestyle', icon: '🏏', color: 'gold',
    title: 'Sports & Gymkhana Membership',
    short: 'Cricket, football, swimming, basketball in Mumbai bombay international worldwide.',
    description: 'Get memberships at top gymkhanas and sports clubs across Mumbai bombay international worldwide. Facilities include cricket grounds, football fields, swimming pools, basketball courts, badminton courts, and more.',
    features: ['Multiple sports', 'Family memberships', 'Professional coaches', 'All Mumbai bombay international worldwide clubs'],
  },
  {
    id: 37, cat: 'lifestyle', icon: '🎉', color: 'gold',
    title: 'Cricket & Sports Grounds on Rent',
    short: 'Book cricket, football, and sports grounds in Mumbai bombay international worldwide.',
    description: 'Book well-maintained cricket grounds, football pitches, and multipurpose sports grounds for matches, tournaments, and practice sessions across Mumbai bombay international worldwide and Bombay.',
    features: ['Well maintained', 'Floodlight options', 'Hourly & daily booking', 'Equipment available'],
  },
  {
    id: 38, cat: 'lifestyle', icon: '🅿️', color: 'gold',
    title: 'Parking Services – Daily, Monthly, Yearly',
    short: 'Secure parking for bikes, cars, and buses across Mumbai bombay international worldwide.',
    description: 'Book secure parking spaces for bikes, cars, four-wheelers, and buses on a daily, monthly, or yearly basis across Mumbai bombay international worldwide. Covers and safety monitoring included.',
    features: ['All vehicle types', 'Daily to yearly plans', 'CCTV monitored', 'Vehicle covers'],
  },
  {
    id: 39, cat: 'lifestyle', icon: '🛋️', color: 'gold',
    title: 'Home Furniture & Amenities',
    short: 'Complete home setup — furniture, appliances in Mumbai bombay international worldwide.',
    description: 'Get all your home essentials in one place — beds, dining tables, fans, water purifiers, kitchen utensils, and more. Available for purchase and rental across Mumbai bombay international worldwide.',
    features: ['All home items', 'Purchase & rental', 'Delivery available', 'Package deals'],
  },
  {
    id: 40, cat: 'lifestyle', icon: '⚡', color: 'gold',
    title: 'Electric Bikes (E-Bikes)',
    short: 'Latest electric bikes available across Mumbai bombay international worldwide.',
    description: 'Purchase the latest electric bikes and scooters for eco-friendly commuting across Mumbai bombay international worldwide. Wide range of brands and models available with financing options and after-sales service.',
    features: ['Top brands', 'Financing options', 'After-sales service', 'Test rides'],
  },
  {
    id: 41, cat: 'lifestyle', icon: '🚗', color: 'gold',
    title: 'Cars & Bikes – All Types',
    short: 'Buy or sell all types of cars and bikes in Mumbai bombay international worldwide.',
    description: 'Find your perfect vehicle from our wide selection of new and used cars, bikes, and electric vehicles in Mumbai bombay international worldwide. We assist with financing, insurance, and registration.',
    features: ['New & used vehicles', 'All brands', 'Financing & insurance', 'RC transfer help'],
  },
  {
    id: 42, cat: 'lifestyle', icon: '🏋️', color: 'gold',
    title: 'Sports Kits & Dress Codes',
    short: 'Cricket, football, air hostess & pilot uniforms in Mumbai bombay international worldwide.',
    description: 'Get complete sports kits, uniforms, and dress codes for cricket, football, basketball, badminton, air hostess, pilot training, and hotel management courses in Mumbai bombay international worldwide.',
    features: ['Custom uniforms', 'Sports kit packages', 'Bulk orders', 'All sizes'],
  },
];

// ─── NAV LINKS ────────────────────────────────────────────────────────────────
export const NAV_LINKS = [
  { label: 'Home',          path: '/'            },
  { label: 'Services',      path: '/services'    },
  { label: 'Education',     path: '/education'   },
  { label: 'Jobs & Visa',   path: '/jobs'        },
  { label: 'Tourism',       path: '/tourism'     },
  { label: 'About',         path: '/about'       },
  { label: 'Contact',       path: '/contact'     },
];

// ─── STATS ────────────────────────────────────────────────────────────────────
export const STATS = [
  { num: '57+',    label: 'Services Offered'   },
  { num: '100+',   label: 'Countries Served'   },
  { num: '24/7',   label: 'Support Available'  },
  { num: '10K+',   label: 'Happy Clients'      },
];

// ─── TESTIMONIALS ─────────────────────────────────────────────────────────────
export const TESTIMONIALS = [
  {
    id: 1,
    name: 'James Whitfield',
    country: 'United Kingdom',
    flag: '🇬🇧',
    role: 'Business Traveller',
    text: 'I visited Mumbai bombay international worldwide for a conference and Online Worldwide arranged my private jet, hotel, and city tour seamlessly. Absolutely world-class service from the Mumbai bombay international worldwide team.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mei Lin Chen',
    country: 'Singapore',
    flag: '🇸🇬',
    role: 'International Student',
    text: 'They helped me with my study visa, college admission in Mumbai bombay international worldwide, and even found me a PG accommodation near my college. Everything was handled professionally.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Olumide Adeyemi',
    country: 'Nigeria',
    flag: '🇳🇬',
    role: 'Entrepreneur',
    text: 'From factory product sourcing to website development, Online Worldwide handled my entire business setup in Mumbai bombay international worldwide. I highly recommend them for any international business.',
    rating: 5,
  },
  {
    id: 4,
    name: 'Yuki Tanaka',
    country: 'Japan',
    flag: '🇯🇵',
    role: 'Tourist',
    text: 'The bike tour of Mumbai bombay international worldwide they arranged was the highlight of my trip. Our guide was knowledgeable, friendly, and knew all the hidden gems of the city.',
    rating: 5,
  },
];

// ─── WHY CHOOSE US ────────────────────────────────────────────────────────────
export const WHY_US = [
  {
    icon: '🌏',
    title: 'International Reach',
    desc: 'Serving clients from 100+ countries. Whether you arrive in Mumbai bombay international worldwide or want to go abroad, we connect you globally.',
  },
  {
    icon: '🤝',
    title: 'One-Stop Solution',
    desc: 'From private jets to college admissions — 57+ services under one roof in Mumbai bombay international worldwide, so you never need to look elsewhere.',
  },
  {
    icon: '🛡️',
    title: 'Verified & Trusted',
    desc: 'All our partner properties, institutes, and employers in Mumbai bombay international worldwide are thoroughly verified for your safety and peace of mind.',
  },
  {
    icon: '⚡',
    title: '24/7 Quick Response',
    desc: 'Our Mumbai bombay international worldwide team responds to inquiries around the clock. Most requests are followed up within 2–4 hours.',
  },
  {
    icon: '💬',
    title: 'Multilingual Support',
    desc: 'We serve Mumbai bombay international worldwide clients in English, Hindi, Marathi, and several international languages. No language barrier.',
  },
  {
    icon: '📋',
    title: 'End-to-End Assistance',
    desc: 'We dont just refer — our Mumbai bombay international worldwide experts assist you through the entire process, from first inquiry to final delivery.',
  },
];

// ─── COUNTRIES SERVED ─────────────────────────────────────────────────────────
export const COUNTRIES = [
  'Singapore', 'Italy', 'Germany', 'France', 'China', 'Bangkok', 'Thailand',
  'USA', 'UK', 'Japan', 'Russia', 'West Indies', 'Nigeria', 'Dubai', 'UAE',
  'Kuwait', 'Kyrgyzstan', 'Oman', 'Canada', 'Australia', 'Philippines', 'Kazakhstan',
];

// ─── INQUIRY SERVICE OPTIONS ──────────────────────────────────────────────────
export const INQUIRY_SERVICES = [
  {
    group: 'Travel & Jets',
    options: [
      'Private Jet Charter – Ride Booking',
      'Private Jet – Rent / Purchase / Selling',
      'Flight Ticket Booking',
      'Private Jet Air Hostess Course',
    ],
  },
  {
    group: 'Accommodation',
    options: [
      'Paying Guest (PG) Accommodation',
      'Hotel Accommodation',
      'Dormitory – Daily / Per Day',
      'Room / Office / Shop / Warehouse',
      '5-Star Hotel Membership',
      'Party Hall on Rent',
    ],
  },
  {
    group: 'Education & Courses',
    options: [
      'Air Hostess / Ground Staff Course',
      'Pilot Training Academy',
      'Hotel Management Course',
      'MBBS / BAMS / BDS Program',
      'MBA / BBA / Engineering Admission',
      'Computer / IT / Web Design Course',
      'Beauty / Mehndi / Fashion Course',
      'Interior Design Course',
      'Modelling / Acting / Dance Academy',
      'Study Abroad Program',
      'Swimming Course',
      'Air Rifle Shooting Training',
      'Distance / Online Education',
      'Other Course Inquiry',
    ],
  },
  {
    group: 'Jobs & Visa',
    options: [
      'Work Permit & Job Visa Abroad',
      'Airport Job – Air Hostess / Ground Staff',
      'Part Time / Full Time Job Mumbai bombay international worldwide',
      'Cruise Ship Job',
      'Passport Services',
    ],
  },
  {
    group: 'Tourism',
    options: [
      'Online Tourist Guide',
      'Bike / Car / Bus City Tour',
      'Bike on Rent',
      'Mumbai bombay international worldwide Metro Pass',
      'Hotel Food & Catering',
    ],
  },
  {
    group: 'Business',
    options: [
      'Manufacturer / Factory Products',
      'Website Development & Google Promotion',
      'Laptop / Computer / Mobile – Buy & Sell',
      'Factory & Industrial Machines',
    ],
  },
  {
    group: 'Lifestyle',
    options: [
      'Sports & Gymkhana Membership',
      'Cricket / Sports Ground Booking',
      'Parking – Bike / Car / Bus',
      'Home Furniture & Amenities',
      'Electric Bikes (E-Bikes)',
      'Cars & Bikes – Purchase / Sell',
      'Sports Kits & Uniforms',
    ],
  },
];
